import authenticationManager from '@/services/auth/manager';
import userAtom from '@/store/auth/user';
import {
  createRootRoute,
  Outlet,
  Link,
  HeadContent,
} from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { executeWhenVisible } from '@tier4/webauto-auth-frontend-client';
import store from '@/store';
import { useAtomValue } from 'jotai';
import { Box, CircularProgress, Typography } from '@mui/material';

const RootLayout = () => {
  const user = useAtomValue(userAtom);

  // const handleClickLogOut = async () => {
  //   await authenticationManager.userManager.signOutRedirect();
  // };

  if (!user) {
    // ログイン/ログアウトのコールバックページは、未ログインでも処理のためにレンダリングが必要
    const isPublicPage =
      location.pathname.startsWith('/login/callback') ||
      location.pathname.startsWith('/logout/callback');

    return (
      <>
        {isPublicPage ? (
          <Outlet />
        ) : (
          <Box
            width="100%"
            height="100vh"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <CircularProgress />
          </Box>
        )}
        <TanStackRouterDevtools />
      </>
    );
  }

  return (
    <>
      <Outlet />
      <TanStackRouterDevtools />
    </>
  );
};

export const Route = createRootRoute({
  beforeLoad: async ({ location }) => {
    if (
      location.pathname.startsWith('/login/callback') ||
      location.pathname.startsWith('/logout/callback')
    ) {
      return;
    }
    const userData = await authenticationManager.userManager.getUser();
    if (userData) {
      store.set(userAtom, userData);
      return;
    }
    const { pathname, searchStr, hash } = location;
    const signinRedirect = async () => {
      const _hash = hash.length ? `#${hash}` : '';
      return await authenticationManager.userManager.signInRedirect({
        url_state: `${pathname}${searchStr}${_hash}`,
      });
    };
    await executeWhenVisible(signinRedirect);
  },
  component: () => (
    <>
      <HeadContent />
      <RootLayout />
    </>
  ),
  notFoundComponent: () => {
    return (
      <Box>
        <Typography variant="h5">404 - Page Not Found</Typography>
        <Link to="/">Go to Home</Link>
      </Box>
    );
  },
});
